
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { User } from '../../lib/models/User'

import BacAlert from '../BacAlert.vue'
import BacButton from '../BacButton.vue'

@Component({
  components: {
    BacAlert,
    BacButton
  }
})
export default class RallyRegisterTShirtSize extends Vue {
  @Prop({ required: true }) user!: User;

  mode = 'show'

  tShirtSizes = [
    'S - Herren',
    'M - Herren',
    'L - Herren',
    'XL - Herren',
    'XXL - Herren',
    '3XL - Herren',
    '4XL - Herren',
    '5XL - Herren',
    'XS - Damen',
    'S - Damen',
    'M - Damen',
    'L - Damen',
    'XL - Damen',
    'XXL - Damen'
  ];

  mounted () {
    this.onUserChange()
  }

  @Watch('user')
  public onUserChange () {
    this.mode = this.user.tShirtSize ? 'show' : 'edit'
  }
}
